import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const AddCategoryPage = () => {
  const { cityId } = useParams();
  const navigate = useNavigate();

const [getCategoryName, setCategoryName] = useState("");
const [getCategorySlag, setCategorySlag] = useState("");
const [getLinkUrlg, setLinkUrl] = useState("");
const [getCategoryMeta_title, setCategoryMeta_title] = useState("");
const [getCategoryMeta_desc, setCategoryMeta_desc] = useState("");
const [getCategoryMeta_keyword, setCategoryMeta_keyword] = useState("");
const [getCategoryPage_desc, setCategoryPage_desc] = useState("");
const [page_title, setPageTitle] = useState("");
  // =========================
  // FETCH SINGLE CATEGORY
  // =========================
  const fetchCategoryById = async () => {
    try {
      const res = await api.get(`/adminVisaAssistanc/getCityNameById/${cityId}`);

      if (res.data.success) {
        const data = res.data.data;
        setCategoryName(data.name);
        setCategorySlag(data.slug);
        setLinkUrl(data.linkUrl);
        setCategoryMeta_title(data.meta_title);
        setCategoryMeta_desc(data.meta_desc);
        setCategoryMeta_keyword(data.meta_keyword);
        setCategoryPage_desc(data.page_desc);
        setPageTitle(data.page_title);

      } else {
        toast.error("City Name not found");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch City Name");
    }
  };

  useEffect(() => {
    if (cityId) {
      fetchCategoryById();
    }
  }, [cityId]);


useEffect(() => {
  const slugData = getCategoryName
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");

  setCategorySlag(slugData);
}, [getCategoryName]);

  // =========================
  // UPDATE CATEGORY
  // =========================
  const updateCategory = async () => {
    if (!getCategoryName) {
      toast.error("City Name required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Update City Name?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes Update"
    });

    if (!confirm.isConfirmed) return;

    try {
      const payload = {
        cityId: cityId,
        category: getCategoryName,
        page_title:page_title,
        slug :getCategorySlag,
        linkUrl :getLinkUrlg,
        meta_title: getCategoryMeta_title,
        meta_desc: getCategoryMeta_desc,
        meta_keyword: getCategoryMeta_keyword,
        page_desc: getCategoryPage_desc,
      };

      const res = await api.put(
        `/adminVisaAssistanc/updateCityName/${cityId}`,
        payload
      );

      if (res.data.success) {
        Swal.fire("Success", "City Name Updated", "success");
        navigate("/city/manage-city-name");
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Server Error");
    }
  };

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm mb-4 bg-primary-subtle">
        <div className="card-body d-flex justify-content-between">
          <h4>Edit City Name</h4>

          <Link to="/city/manage-city-name" className="btn btn-secondary btn-sm">
            <ArrowLeft size={16} /> Back
          </Link>
        </div>
      </div>

      {/* FORM */}
      <div className="card">
        <div className="card-body">

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>City Name</th>
                <th>Slug</th>
              </tr>
            </thead>

            <tbody>

                <tr >
                  <td>
                    <input
                      className="form-control"
                      value={getCategoryName}
                      onChange={(e) =>
                        setCategoryName(e.target.value)
                      }
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      readOnly
                      value={getCategorySlag}
                      onChange={(e) =>
                        setCategorySlag(e.target.value)
                      }
                    />
                  </td>
                </tr>
                
       
            </tbody>
              <thead>
              <tr>
                <th>   <div className="d-flex align-items-center gap-2">
                        <span>Meta Title</span>
                        <small className={`d-block mt-1 ${
                           (getCategoryMeta_title?.length || 0) > 80 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getCategoryMeta_title?.length || 0)}/80 Characters)
                        </small>
                     </div></th>
                <th>
                     <div className="d-flex align-items-center gap-2">
                        <span>Meta Description</span>
                        <small className={`d-block mt-1 ${
                           (getCategoryMeta_desc?.length  || 0)> 160 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getCategoryMeta_desc?.length || 0)}/160 Characters)
                        </small>
                     </div>
                </th>
              </tr>
            </thead>
            
            <tbody>

                <tr >
                  <td>
                    <textarea
                  rows="3" className="form-control" maxLength={80} value={getCategoryMeta_title} onChange={(e) => setCategoryMeta_title(e.target.value)} />
                     {(getCategoryMeta_title?.length || 0) >= 79 && (getCategoryMeta_title?.length || 0) <= 80 && (
                     <small className="text-danger">
                     ⚠️ Almost reached limit
                     </small>
                     )}
                  </td>

                  <td>
                   <textarea className="form-control"  rows="3"  maxLength={160} value={getCategoryMeta_desc} onChange={(e) => setCategoryMeta_desc(e.target.value)} />
               {(getCategoryMeta_desc?.length || 0 )>= 159 && (getCategoryMeta_desc?.length || 0) <= 160 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}
                  </td>
                </tr>
                
       
            </tbody>
             <thead>
              <tr>
                <th>
                     <div className="d-flex align-items-center gap-2">
               <span>Meta Keyword  </span><small className={`d-block mt-1 ${
                  (getCategoryMeta_keyword?.length || 0 )> 255 ? "text-danger" : "text-muted"
               }`}>
               ({(getCategoryMeta_keyword?.length || 0 )}/255 Characters)
               </small>
               </div>
                </th>
                <th>Page Description</th>
              </tr>
            </thead>
            <tbody>

                <tr >
                  <td>
                    <textarea
                  rows="3" maxLength={255} className="form-control" value={getCategoryMeta_keyword} onChange={(e) => setCategoryMeta_keyword(e.target.value)} ></textarea>
               {(getCategoryMeta_keyword?.length || 0)>= 254 && (getCategoryMeta_keyword?.length || 0) <= 255 && (
               <small className="text-danger">
               ⚠️ Almost reached limit
               </small>
               )}
                  </td>

                  <td>
                    <textarea
                  rows="3"
                      className="form-control"
                      
                      value={getCategoryPage_desc}
                      onChange={(e) =>
                        setCategoryPage_desc(e.target.value)
                      }
                    />
                  </td>
                </tr>
                
      
            </tbody>
               <thead>
              <tr>
                <th>Page Title</th>
                <th>link</th>
              </tr>
            </thead>
            <tbody>
               <tr>
                  <td>
                    <input
                  typr="text"
                      className="form-control"
                      
                      value={page_title}
                      onChange={(e) =>
                        setPageTitle(e.target.value)
                      }
                    />
                  </td>
         <td>
                    <input
                  typr="text"
                      className="form-control"
                      
                      value={getLinkUrlg}
                      onChange={(e) =>
                        setLinkUrl(e.target.value)
                      }
                    />
                  </td>
       </tr>
            </tbody>
       
          </table>

          <button className="btn btn-success mt-3" onClick={updateCategory}>
            Update City Name
          </button>

        </div>
      </div>
    </div>
  );
};

export default AddCategoryPage;